import React, {Component} from "react"
import { TileLayer } from 'react-leaflet'
import MapContainer from './MapContainer';
import ErrorImage from '../ErrorImage';
import POIMarker from './POIMarker';
import TruckMarker from './TruckMarker';
import UserMarker from './UserMarker';
import CombinedButton from './CombinedButton';
import UserCenterButton from './UserCenterButton';
import OpenAppButton from './OpenAppButton';
import {store} from "../../App";
import { connect } from 'react-redux';
import { setHideHeader, setToast } from "../../Redux/OverlayActions";
import SilentCallButton from "./SilentCallButton";

class TrackerView extends Component {
    constructor() {
        super();
        this.state = {
            hasInternet: true,
            hasLocationPermission: false,
            deniedLocationPermission: false,
            userLocation: null,
            pois: [],
            karren: [],
            trackid: "firstDrawUser",
            map: null,
            firstDraw: true,
            lastFocusLatitude: 0,
            lastFocusLongitude: 0,
            // New loading/error states
            isLoading: true,
            loadError: null,
            lastSuccessfulFetch: null,
            consecutiveErrors: 0,

        };

        this.setUdid = this.setUdid.bind(this);
        this.checkIframeMode = this.checkIframeMode.bind(this);
        // this.checkServerHeartbeat = this.checkServerHeartbeat.bind(this);
        this.getPOIdata = this.getPOIdata.bind(this);
        this.getMapdata = this.getMapdata.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.handleMapClick = this.handleMapClick.bind(this);
        this.setMap = this.setMap.bind(this);
        this.moveMap = this.moveMap.bind(this);
        this.checkLocationPermission = this.checkLocationPermission.bind(this);
    }

    componentDidMount() {
        this.setUdid();
        this.checkIframeMode();
        // this.checkServerHeartbeat();
        this.checkLocationPermission();

        // Add visibility change listener to pause/resume polling when tab is hidden
        this.handleVisibilityChange = this.handleVisibilityChange.bind(this);
        document.addEventListener('visibilitychange', this.handleVisibilityChange);
    }

    componentWillUnmount() {
        if (this.getMapdataInterval) clearTimeout(this.getMapdataInterval);
        document.removeEventListener('visibilitychange', this.handleVisibilityChange);
    }

    handleVisibilityChange() {
        if (document.hidden) {
            // Tab is hidden - pause polling to save battery and bandwidth
            console.log('[TrackerView] Tab hidden, pausing map data polling');
            if (this.getMapdataInterval) {
                clearTimeout(this.getMapdataInterval);
                this.getMapdataInterval = null;
            }
        } else {
            // Tab is visible again - resume polling
            console.log('[TrackerView] Tab visible, resuming map data polling');
            if (!this.getMapdataInterval && this.state.map !== null) {
                this.getMapdata();
            }
        }
    }

    setUdid() {
        const udid = window.localStorage.getItem('udid') || '';
        if (udid === '') {
            const nav = window.navigator;
            const screen = window.screen;
            let guid = nav.mimeTypes.length;
            guid += nav.userAgent.replace(/\D+/g, '');
            guid += nav.plugins.length;
            guid += screen.height || '';
            guid += screen.width || '';
            guid += screen.pixelDepth || '';

            localStorage.setItem('udid', guid);
        }
    }

    checkIframeMode() {
        const url = new URL(window.location.href);
        const c = url.searchParams.get("iframe");
        if (c === "no") {
            store.dispatch(setHideHeader(true));
        }
    }

    checkLocationPermission() {
        const that = this;
        navigator.permissions && navigator.permissions.query({name: 'geolocation'}).then(function(PermissionStatus) {
            if('granted' === PermissionStatus.state) {
                that.setState({
                    hasLocationPermission: true,
                    deniedLocationPermission: false,
                });
            } else if('denied' === PermissionStatus.state) {
                that.setState({
                    hasLocationPermission: false,
                    deniedLocationPermission: true,
                });
            } else {
                that.setState({
                    hasLocationPermission: false,
                    deniedLocationPermission: false,
                });
            }
        });
        if (!navigator.permissions) {
            //This browser does not have the permissions API
            //Fallback to localstorage polyfill
            const geolocationState = localStorage.getItem('geolocation') || '';
            if('granted' === geolocationState) {
                that.setState({
                    hasLocationPermission: true,
                    deniedLocationPermission: false,
                });
            } else if('denied' === geolocationState) {
                that.setState({
                    hasLocationPermission: false,
                    deniedLocationPermission: true,
                });
            } else {
                that.setState({
                    hasLocationPermission: false,
                    deniedLocationPermission: false,
                });
            }
        }
    }

    getPOIdata() {
        const url = process.env.REACT_APP_ICECORP_API_HREF+"v1/pointofinterestmarkerdata?company_id="+process.env.REACT_APP_COMPANY_ID;
        fetch(url)
        .then(response => {
            if (!response.ok) {
                throw new Error(`HTTP ${response.status}`);
            }
            return response.json();
        })
        .then(data => {
            const pois = data.data;

            this.setState({
                pois: pois,
            });
        })
        .catch((error) => {
            console.warn('[TrackerView] Failed to fetch POI data:', error.message);
        });
    }

    getMapdata() {
        const url = process.env.REACT_APP_ICECORP_API_HREF+"v1/icecreamvanmarkerdata?company_id="+process.env.REACT_APP_COMPANY_ID+"&has_working_day=1";
        fetch(url)
        .then(response => {
            if (!response.ok) {
                throw new Error(`HTTP ${response.status}`);
            }
            return response.json();
        })
        .then(data => {
            const karren = data.data || [];

            if (this.state.firstDraw && this.state.map !== null) {
                try {
                    const container = this.state.map.getContainer();
                    if (container && container.offsetParent !== null) {
                        this.state.map.panTo({
                            lat: process.env.REACT_APP_DEFAULT_LAT,
                            lng: process.env.REACT_APP_DEFAULT_LNG,
                        });
                    }
                } catch (error) {
                    console.warn('[TrackerView] Initial map pan failed:', error.message);
                }
            }

            karren.forEach(kar => {
                if ("kar"+kar.id === this.state.trackid) {
                    this.moveMap(kar.latitude, kar.longitude);
                }
            });

            const that = this;

            if (this.state.hasLocationPermission) {
                navigator.geolocation.getCurrentPosition(function(geoposition) {
                    const userLocation = {
                        lat: geoposition.coords.latitude,
                        lng: geoposition.coords.longitude
                    }

                    that.setState({
                        userLocation: userLocation,
                    });

                    if (that.state.trackid === "firstDrawUser") {
                        that.moveMap(geoposition.coords.latitude, geoposition.coords.longitude);
                        that.setState({
                            trackid: "user",
                        });
                    }
                });
            }

            // Success - reset error state and update timestamp
            this.setState({
                hasInternet: true,
                karren: karren,
                firstDraw: false,
                isLoading: false,
                loadError: null,
                lastSuccessfulFetch: Date.now(),
                consecutiveErrors: 0,
            });

            if (this.getMapdataInterval) clearTimeout(this.getMapdataInterval);
            this.getMapdataInterval = setTimeout(this.getMapdata, 3000);
        })
        .catch((error) => {
            const newConsecutiveErrors = this.state.consecutiveErrors + 1;
            console.warn('[TrackerView] Failed to fetch map data:', error.message, `(attempt ${newConsecutiveErrors})`);

            // Show toast notification after 3 consecutive failures (but only once)
            if (newConsecutiveErrors === 3) {
                store.dispatch(setToast({
                    theme: 'warning',
                    message: 'Verbindingsprobleem - gegevens kunnen verouderd zijn',
                }));
            }

            // Keep existing data if we have it, just mark the error
            this.setState({
                loadError: error.message,
                consecutiveErrors: newConsecutiveErrors,
                isLoading: false,
                // Only set hasInternet to false if we have no data AND multiple failures
                hasInternet: this.state.karren.length > 0 || newConsecutiveErrors < 5,
            });

            if (this.getMapdataInterval) clearTimeout(this.getMapdataInterval);
            // Use exponential backoff on errors (max 30 seconds)
            const backoffTime = Math.min(3000 * Math.pow(1.5, newConsecutiveErrors - 1), 30000);
            this.getMapdataInterval = setTimeout(this.getMapdata, backoffTime);
        });
    }

    static defaultProps = {
        center: {
            lat: process.env.REACT_APP_DEFAULT_LAT,
            lng: process.env.REACT_APP_DEFAULT_LNG,
        },
        zoom: 13
    };

    handleMapClick() {
        this.setState({
            trackid: "",
            lastFocusLatitude: 0,
            lastFocusLongitude: 0,
        });
    }

    handleClick(trackid, lat, long) {
        if (lat !== 0 || long !== 0) {
            this.moveMap(lat, long);
        }

        this.setState({
            trackid: trackid,
        });
    }

    moveMap(lat, long) {
        if (lat !== this.state.lastFocusLatitude || long !== this.state.lastFocusLongitude) {
            this.setState({
                lastFocusLatitude: lat,
                lastFocusLongitude: long,
            });
            // Check if map is properly initialized before panning
            // The _leaflet_pos error occurs when map container is not ready
            if (this.state.map !== null && !(lat === 0 && long === 0)) {
                try {
                    // Verify map container is still in DOM and initialized
                    const container = this.state.map.getContainer();
                    if (container && container.offsetParent !== null) {
                        this.state.map.panTo({
                            lat: parseFloat(lat),
                            lng: parseFloat(long)
                        });
                    }
                } catch (error) {
                    console.warn('[TrackerView] Map pan failed, map may not be ready:', error.message);
                }
            }
        }
    }

    setMap(map) {
        if (!this.state.map) {
            this.setState({
                map: map
            });

            this.getPOIdata();
            this.getMapdata();
        }
    }

    // Render stale data indicator
    renderStaleDataIndicator() {
        const { lastSuccessfulFetch, consecutiveErrors } = this.state;
        if (consecutiveErrors > 0 && lastSuccessfulFetch) {
            const secondsAgo = Math.floor((Date.now() - lastSuccessfulFetch) / 1000);
            if (secondsAgo > 30) {
                return (
                    <div className="stale-data-indicator" style={{
                        position: 'absolute',
                        top: '10px',
                        left: '50%',
                        transform: 'translateX(-50%)',
                        backgroundColor: 'rgba(255, 193, 7, 0.9)',
                        color: '#333',
                        padding: '8px 16px',
                        borderRadius: '20px',
                        fontSize: '12px',
                        fontWeight: '500',
                        zIndex: 1000,
                        boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '6px',
                    }}>
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <circle cx="12" cy="12" r="10"/>
                            <line x1="12" y1="8" x2="12" y2="12"/>
                            <line x1="12" y1="16" x2="12.01" y2="16"/>
                        </svg>
                        Laatste update: {secondsAgo}s geleden
                    </div>
                );
            }
        }
        return null;
    }

    // Render loading skeleton
    renderLoadingSkeleton() {
        return (
            <div className="map-loading-skeleton" style={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: '#e8e8e8',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: 500,
            }}>
                <div style={{
                    width: '50px',
                    height: '50px',
                    border: '3px solid #ccc',
                    borderTopColor: '#ffd700',
                    borderRadius: '50%',
                    animation: 'spin 1s linear infinite',
                }} />
                <p style={{ marginTop: '16px', color: '#666', fontSize: '14px' }}>
                    Kaart laden...
                </p>
                <style>{`
                    @keyframes spin {
                        to { transform: rotate(360deg); }
                    }
                `}</style>
            </div>
        );
    }

    render() {
        if (this.state.hasInternet) {
            const POIMarkers = this.state.pois.map(poi => <POIMarker
                key = {"poi"+poi.id}
                trackid = {"poi"+poi.id}
                poi = {poi}
                lat={poi.latitude}
                lng={poi.longitude}
                Tooltip={"poi"+poi.id === this.state.trackid ? "true" : "false"}
                onClick={this.handleClick}
            />);

            const TruckMarkers = this.state.karren.map(kar => <TruckMarker
                key = {"kar"+kar.id}
                trackid = {"kar"+kar.id}
                kar = {kar}
                position={{lat: kar.latitude, lng: kar.longitude}}
                lat={kar.latitude}
                lng={kar.longitude}
                Tooltip={"kar"+kar.id === this.state.trackid ? "true" : "false"}
                onClick={this.handleClick}
            />);

            const UserMarkerIcon = (this.state.hasLocationPermission && this.state.userLocation !== null ? <UserMarker
                lat={this.state.userLocation.lat}
                lng={this.state.userLocation.lng}
                Latitude={this.state.userLocation.lat}
                Longitude={this.state.userLocation.lng}
                trackid = {"user"}
                Tooltip={"user" === this.state.trackid ? "true" : "false"}
                onClick={this.handleClick}
            /> : null);

            const userCenterButton = (this.state.hasLocationPermission && this.state.userLocation !== null ? <UserCenterButton
                Latitude={this.state.userLocation.lat}
                Longitude={this.state.userLocation.lng}
                trackid = {"user"}
                Tooltip={"user" === this.state.trackid ? "true" : "false"}
                onClick={this.handleClick}
            /> : null);

            const mapdivClass = (this.props.hideHeader ? "mapdivNoHeader" : "mapdiv");

            const contentClass = (this.props.hideHeader ? "content contentNoHeader" : "content");
            const button = (this.props.hideHeader ? <OpenAppButton handleMapClick={this.handleMapClick} /> : <CombinedButton handleMapClick={this.handleMapClick} />);
            const silentButton = (this.props.hideHeader ? null : <SilentCallButton handleMapClick={this.handleMapClick} />);

            // eslint-disable-next-line no-unused-vars
            const position = [51.505, -0.09];
            return (
                <main>
                    <div className={contentClass}>
                        {/* Important! Always set the container height explicitly */}
                        <div className={mapdivClass} style={{ position: 'relative' }}>
                            {this.state.isLoading && this.state.karren.length === 0 && this.renderLoadingSkeleton()}
                            {this.renderStaleDataIndicator()}
                            <MapContainer center={this.props.center} zoom={this.props.zoom} onMapReady={this.setMap}>
                                <TileLayer
                                    attribution='<a href="https://www.stadiamaps.com/">&copy; Stadia Maps</a> | <a href="https://openmaptiles.org/">&amp;copy OpenMapTiles</a> | <a href="https://www.openstreetmap.org/about/">&amp;copy OpenStreetMap contributors</a>'
                                    url={process.env.REACT_APP_API_HREF+"proxy.php?z={z}&x={x}&y={y}"}
                                />
                                {UserMarkerIcon}
                                {POIMarkers}
                                {TruckMarkers}
                            </MapContainer>
                            {button}
                            {userCenterButton}
                            {silentButton}
                        </div>
                    </div>
                </main>
            )
        } else {
            return (
                <main>
                    <div className="content">
                        <ErrorImage text="Je bent offline" subtext="Sommige onderdelen van de app werken mogelijk niet"/>
                    </div>
                </main>
            )
        }
    }
}

function mapStateToProps(state) {
    return {
        hideHeader: state.overlay.hideHeader || false,
    }
}

export default connect(mapStateToProps)(TrackerView);
